import React, { useState } from 'react';
import '../../styles/midnight-lab.css';

function InventoryModule() {
  const [items, setItems] = useState([
    { id: 1, sku: 'REV-001', name: 'REV HD Hex Motor', category: 'Motors', location: 'A1', quantity: 8, threshold: 4, unitCost: 45.99, supplier: 'REV Robotics' },
    { id: 2, sku: 'REV-002', name: 'Mecanum Wheel Set', category: 'Wheels', location: 'B2', quantity: 2, threshold: 4, unitCost: 89.99, supplier: 'REV Robotics' },
    { id: 3, sku: 'REV-003', name: 'Control Hub', category: 'Electronics', location: 'C1', quantity: 3, threshold: 2, unitCost: 199.99, supplier: 'REV Robotics' },
    { id: 4, sku: 'REV-004', name: 'Linear Slide Kit', category: 'Mechanisms', location: 'A3', quantity: 1, threshold: 2, unitCost: 129.99, supplier: 'REV Robotics' }
  ]);
  const [movements, setMovements] = useState([
    { id: 1, itemId: 1, itemName: 'REV HD Hex Motor', deltaQty: -2, reason: 'Used in robot build', user: 'Alex J.', timestamp: '2025-01-15 10:30' },
    { id: 2, itemId: 2, itemName: 'Mecanum Wheel Set', deltaQty: -1, reason: 'Replacement', user: 'Sam C.', timestamp: '2025-01-14 14:20' },
    { id: 3, itemId: 1, itemName: 'REV HD Hex Motor', deltaQty: 10, reason: 'Restocked', user: 'Admin', timestamp: '2025-01-13 09:15' }
  ]);
  const [filter, setFilter] = useState('all');
  const [showAddModal, setShowAddModal] = useState(false);
  const [newItem, setNewItem] = useState({
    sku: '', name: '', category: '', location: '', quantity: 0, threshold: 0, unitCost: 0, supplier: ''
  });

  const lowStockItems = items.filter(item => item.quantity <= item.threshold);
  const filteredItems = filter === 'low-stock' ? lowStockItems : items;

  const handleAddItem = () => {
    const item = { ...newItem, id: items.length + 1 };
    setItems([...items, item]);
    setShowAddModal(false);
    setNewItem({ sku: '', name: '', category: '', location: '', quantity: 0, threshold: 0, unitCost: 0, supplier: '' });
  };

  const handleMovement = (itemId, deltaQty, reason) => {
    const item = items.find(i => i.id === itemId);
    const updatedItems = items.map(i =>
      i.id === itemId ? { ...i, quantity: Math.max(0, i.quantity + deltaQty) } : i
    );
    setItems(updatedItems);
    setMovements([{
      id: movements.length + 1,
      itemId,
      itemName: item.name,
      deltaQty,
      reason,
      user: 'Current User',
      timestamp: new Date().toLocaleString()
    }, ...movements]);
  };

  return (
    <div>
      {/* Header */}
      <div style={{
        marginBottom: 'var(--space-8)',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        flexWrap: 'wrap',
        gap: 'var(--space-4)'
      }}>
        <div>
          <h1 style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'clamp(2rem, 4vw, 3rem)',
            fontWeight: 700,
            color: 'var(--color-text-primary)',
            marginBottom: 'var(--space-2)',
            letterSpacing: '-0.02em'
          }}>
            Inventory
          </h1>
          <p style={{
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-base)',
            color: 'var(--color-text-secondary)'
          }}>
            Manage parts, track movements, and monitor stock levels
          </p>
        </div>
        <button
          onClick={() => setShowAddModal(true)}
          style={{
            padding: 'var(--space-3) var(--space-6)',
            backgroundColor: 'var(--color-text-primary)',
            color: 'var(--color-text-light)',
            fontFamily: 'var(--font-sans)',
            fontSize: 'var(--text-sm)',
            fontWeight: 600,
            border: 'none',
            cursor: 'pointer',
            transition: 'all var(--transition-base)'
          }}
          onMouseEnter={(e) => {
            e.target.style.backgroundColor = 'var(--color-frozen-lake)';
            e.target.style.color = 'var(--color-text-primary)';
          }}
          onMouseLeave={(e) => {
            e.target.style.backgroundColor = 'var(--color-text-primary)';
            e.target.style.color = 'var(--color-text-light)';
          }}
        >
          + Add Item
        </button>
      </div>

      {/* Alerts */}
      {lowStockItems.length > 0 && (
        <div style={{
          padding: 'var(--space-4)',
          marginBottom: 'var(--space-6)',
          backgroundColor: 'rgba(152, 206, 0, 0.1)',
          borderLeft: '4px solid var(--color-yellow-green)',
          fontFamily: 'var(--font-sans)'
        }}>
          <div style={{
            fontWeight: 600,
            color: 'var(--color-text-primary)',
            marginBottom: 'var(--space-2)'
          }}>
            Low Stock Alert: {lowStockItems.length} item(s) below threshold
          </div>
          <div style={{
            fontSize: 'var(--text-sm)',
            color: 'var(--color-text-secondary)'
          }}>
            {lowStockItems.map(item => item.name).join(', ')}
          </div>
        </div>
      )}

      {/* Filters */}
      <div style={{
        display: 'flex',
        gap: 'var(--space-2)',
        marginBottom: 'var(--space-6)',
        borderBottom: '1px solid rgba(0, 16, 17, 0.1)',
        paddingBottom: 'var(--space-4)'
      }}>
        {['all', 'low-stock'].map(f => (
          <button
            key={f}
            onClick={() => setFilter(f)}
            style={{
              padding: 'var(--space-2) var(--space-4)',
              backgroundColor: filter === f ? 'var(--color-text-primary)' : 'transparent',
              color: filter === f ? 'var(--color-text-light)' : 'var(--color-text-primary)',
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-sm)',
              fontWeight: 600,
              border: 'none',
              cursor: 'pointer',
              textTransform: 'capitalize',
              transition: 'all var(--transition-base)'
            }}
          >
            {f.replace('-', ' ')}
          </button>
        ))}
      </div>

      {/* Items Table */}
      <div style={{
        overflowX: 'auto',
        marginBottom: 'var(--space-8)'
      }}>
        <table style={{
          width: '100%',
          borderCollapse: 'collapse',
          fontFamily: 'var(--font-sans)'
        }}>
          <thead>
            <tr style={{
              borderBottom: '2px solid rgba(0, 16, 17, 0.1)'
            }}>
              {['SKU', 'Name', 'Category', 'Location', 'Quantity', 'Threshold', 'Unit Cost', 'Supplier', 'Actions'].map(header => (
                <th key={header} style={{
                  padding: 'var(--space-3)',
                  textAlign: 'left',
                  fontFamily: 'var(--font-sans)',
                  fontSize: 'var(--text-sm)',
                  fontWeight: 600,
                  color: 'var(--color-text-primary)',
                  textTransform: 'uppercase',
                  letterSpacing: '0.5px'
                }}>
                  {header}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {filteredItems.map(item => (
              <tr key={item.id} style={{
                borderBottom: '1px solid rgba(0, 16, 17, 0.1)',
                backgroundColor: item.quantity <= item.threshold ? 'rgba(152, 206, 0, 0.05)' : 'transparent'
              }}>
                <td style={{ padding: 'var(--space-3)' }}>{item.sku}</td>
                <td style={{ padding: 'var(--space-3)', fontWeight: 600 }}>{item.name}</td>
                <td style={{ padding: 'var(--space-3)' }}>{item.category}</td>
                <td style={{ padding: 'var(--space-3)' }}>{item.location}</td>
                <td style={{
                  padding: 'var(--space-3)',
                  color: item.quantity <= item.threshold ? 'var(--color-yellow-green)' : 'var(--color-text-primary)',
                  fontWeight: 600
                }}>
                  {item.quantity}
                </td>
                <td style={{ padding: 'var(--space-3)' }}>{item.threshold}</td>
                <td style={{ padding: 'var(--space-3)' }}>${item.unitCost.toFixed(2)}</td>
                <td style={{ padding: 'var(--space-3)' }}>{item.supplier}</td>
                <td style={{ padding: 'var(--space-3)' }}>
                  <div style={{ display: 'flex', gap: 'var(--space-2)' }}>
                    <button
                      onClick={() => handleMovement(item.id, 1, 'Added')}
                      style={actionButtonStyle}
                    >
                      +
                    </button>
                    <button
                      onClick={() => handleMovement(item.id, -1, 'Removed')}
                      style={actionButtonStyle}
                    >
                      −
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Movements Log */}
      <div>
        <h2 style={{
          fontFamily: 'var(--font-sans)',
          fontSize: 'var(--text-2xl)',
          fontWeight: 600,
          color: 'var(--color-text-primary)',
          marginBottom: 'var(--space-6)'
        }}>
          Movements Log
        </h2>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 'var(--space-3)'
        }}>
          {movements.map(movement => (
            <div
              key={movement.id}
              style={{
                padding: 'var(--space-4)',
                borderBottom: '1px solid rgba(0, 16, 17, 0.1)',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center'
              }}
            >
              <div>
                <div style={{
                  fontFamily: 'var(--font-sans)',
                  fontSize: 'var(--text-base)',
                  fontWeight: 600,
                  color: 'var(--color-text-primary)'
                }}>
                  {movement.itemName}
                </div>
                <div style={{
                  fontFamily: 'var(--font-sans)',
                  fontSize: 'var(--text-sm)',
                  color: 'var(--color-text-secondary)'
                }}>
                  {movement.reason} • {movement.user} • {movement.timestamp}
                </div>
              </div>
              <div style={{
                fontFamily: 'var(--font-sans)',
                fontSize: 'var(--text-lg)',
                fontWeight: 700,
                color: movement.deltaQty > 0 ? 'var(--color-frozen-lake)' : 'var(--color-yellow-green)'
              }}>
                {movement.deltaQty > 0 ? '+' : ''}{movement.deltaQty}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Add Item Modal */}
      {showAddModal && (
        <div
          onClick={() => setShowAddModal(false)}
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0, 16, 17, 0.8)',
            zIndex: 2000,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            padding: 'var(--space-4)'
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: 'var(--color-bg-primary)',
              padding: 'var(--space-8)',
              maxWidth: '600px',
              width: '100%',
              maxHeight: '90vh',
              overflowY: 'auto'
            }}
          >
            <h2 style={{
              fontFamily: 'var(--font-sans)',
              fontSize: 'var(--text-2xl)',
              fontWeight: 700,
              color: 'var(--color-text-primary)',
              marginBottom: 'var(--space-6)'
            }}>
              Add Inventory Item
            </h2>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-4)' }}>
              {['sku', 'name', 'category', 'location', 'supplier'].map(field => (
                <div key={field}>
                  <label style={{
                    display: 'block',
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-sm)',
                    fontWeight: 600,
                    color: 'var(--color-text-primary)',
                    marginBottom: 'var(--space-2)',
                    textTransform: 'capitalize'
                  }}>
                    {field}
                  </label>
                  <input
                    type="text"
                    value={newItem[field]}
                    onChange={(e) => setNewItem({ ...newItem, [field]: e.target.value })}
                    style={inputStyle}
                  />
                </div>
              ))}
              {['quantity', 'threshold', 'unitCost'].map(field => (
                <div key={field}>
                  <label style={{
                    display: 'block',
                    fontFamily: 'var(--font-sans)',
                    fontSize: 'var(--text-sm)',
                    fontWeight: 600,
                    color: 'var(--color-text-primary)',
                    marginBottom: 'var(--space-2)',
                    textTransform: 'capitalize'
                  }}>
                    {field.replace(/([A-Z])/g, ' $1').trim()}
                  </label>
                  <input
                    type="number"
                    value={newItem[field]}
                    onChange={(e) => setNewItem({ ...newItem, [field]: parseFloat(e.target.value) || 0 })}
                    style={inputStyle}
                  />
                </div>
              ))}
            </div>
            <div style={{
              display: 'flex',
              gap: 'var(--space-4)',
              marginTop: 'var(--space-6)'
            }}>
              <button onClick={handleAddItem} style={buttonStyle}>
                Add Item
              </button>
              <button onClick={() => setShowAddModal(false)} style={{ ...buttonStyle, backgroundColor: 'transparent', color: 'var(--color-text-primary)' }}>
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const actionButtonStyle = {
  padding: 'var(--space-1) var(--space-3)',
  backgroundColor: 'var(--color-bg-secondary)',
  border: '1px solid rgba(0, 16, 17, 0.1)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  cursor: 'pointer',
  transition: 'all var(--transition-base)'
};

const inputStyle = {
  width: '100%',
  padding: 'var(--space-3)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  border: '1px solid rgba(0, 16, 17, 0.1)',
  backgroundColor: 'var(--color-bg-primary)',
  color: 'var(--color-text-primary)'
};

const buttonStyle = {
  padding: 'var(--space-3) var(--space-6)',
  backgroundColor: 'var(--color-text-primary)',
  color: 'var(--color-text-light)',
  fontFamily: 'var(--font-sans)',
  fontSize: 'var(--text-base)',
  fontWeight: 600,
  border: 'none',
  cursor: 'pointer',
  transition: 'all var(--transition-base)'
};

export default InventoryModule;

